<template>
  <v-row justify="center">
    <v-card>
      <v-toolbar color="primary white--text" flat>
        <v-toolbar-title>ESTO NO SE USA, SE CREO APARTE UN PROYECO NUEVO EN VUEjs</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text class="py-2" v-if="factura && matriz" id="factura_html">
        <v-row no-gutters style="font-size:0.78em">
          <v-col style="text-align:center" sm="4">
            <p style="margin:0">
              <b>{{ nit.nombre }}</b>
            </p>
            <p style="margin:0">
              <b>SUCURSAL N. {{ matriz.numero_sucursal }}</b>
            </p>
            <p style="margin:0">No. Punto de Venta {{ factura.codigoPuntoVenta }}</p>
            <p style="margin:0">{{ matriz.direccion }}</p>
            <p style="margin:0">{{ nit.ciudad }}</p>
            <p style="margin:0">Teléfono: {{ matriz.telefono }}</p>
          </v-col>
          <v-col></v-col>
          <v-col></v-col>
          <v-col>
            <p style="margin:4px"><b>NIT</b></p>
            <p style="margin:4px"><b>FACTURA N°</b></p>
            <p style="margin:4px"><b>CÓD. AUTORIZACIÓN</b></p>
          </v-col>
          <v-col>
            <p style="margin:4px">{{ factura.nit }}</p>
            <p style="margin:4px">{{ factura.numeroFactura }}</p>
            <p style="margin:4px">{{ cortarCuf(factura.cuf) }}</p>
          </v-col>
        </v-row>
        <h4 class="text-center" style="margin:1.8em 0 0 0;padding:0;color:black!important"><b>FACTURA</b></h4>
        <p style="margin:0;text-align:center;padding:0;line-height: initial;">
          <small>(Con Derecho a Crédito Fiscal)</small>
        </p>

        <div class="w-100">
          <img v-if="UNIDAD_NEGOCIO_ID === 1" src="/img/Picture2.png" class="watermark2" alt="watermark2" />
          <img v-if="UNIDAD_NEGOCIO_ID === 1" src="/img/Picture1.png" class="watermark1" alt="watermark1" />
          <br />

          <v-row no-gutters style="font-size:0.9em;margin-bottom:2em">
            <v-col sm="3">
              <p style="margin:2px"><b>Fecha:</b></p>
              <p style="margin:2px"><b>Nombre/Razón Social:</b></p>
              <p style="margin:2px"><b>Nombre Estudiante:</b></p>
            </v-col>
            <v-col sm="5">
              <p style="margin:2px">{{ parsefechaint(factura.fechaEmision) }}</p>
              <p style="margin:2px">{{ factura.nombreRazonSocial.toUpperCase() }}</p>
              <p style="margin:2px">{{ factura.nombreEstudiante.toUpperCase() }}</p>
            </v-col>

            <v-col>
              <p style="margin:2px"><b>NIT/CI/CEX:</b></p>
              <p style="margin:2px"><b>Cod. Cliente:</b></p>
              <p style="margin:2px"><b>Periodo Facturado:</b></p>
            </v-col>
            <v-col sm="1">
              <p style="margin:2px">{{ factura.numeroDocumento }}</p>
              <p style="margin:2px">{{ factura.idCliente }}</p>
              <p style="margin:2px">{{ factura.periodoFacturado }}</p>
            </v-col>
          </v-row>

          <table border="1">
            <thead style="">
              <tr style="text-align:center;color:black!important">
                <td style="width:7em;padding:1em 0 1em 0">CÓDIGO SERVICIO</td>
                <td style="width:6em">CANTIDAD</td>
                <td style="width:7em">UNIDAD DE MEDIDA</td>
                <td>DESCRIPCIÓN</td>
                <td style="width:6em">PRECIO UNITARIO</td>
                <td style="width:7em">DESCUENTO</td>
                <td style="width:7em">SUBTOTAL</td>
              </tr>
            </thead>
            <tbody>
              <tr class="item-tr" v-for="(item, index) in factura.detalle" :key="index">
                <td class="item-td text-left">{{ item.concepto_pago_id }}</td>
                <td class="item-td text-center">1</td>
                <td class="item-td text-center">{{ item.unidad_medida_abreviatura }}</td>
                <td class="item-td text-left">{{ item.concepto }}</td>
                <td class="item-td text-right">{{ numeralFormat(item.monto) }}</td>
                <td class="item-td text-right">{{ numeralFormat() }}</td>
                <td class="item-td text-right">{{ numeralFormat(item.monto) }}</td>
              </tr>

              <!--  -->
              <tr class="item-tr" style="color: black">
                <td colspan="4" rowspan="7">
                  SON {{ (literal + '').toUpperCase() }} <strong> 00/100 BOLIVIANOS</strong>
                </td>
                <td :colspan="2" class="text-right">SUBTOTAL Bs.</td>
                <td class="item-td text-right">{{ numeralFormat(factura.montoTotal) }}</td>
              </tr>
              <tr class="item-tr">
                <td :colspan="2" class="text-right">DESCUENTO Bs.</td>
                <td class="item-td text-right">{{ numeralFormat(factura.descuentoAdicional) }}</td>
              </tr>
              <tr class="item-tr">
                <td :colspan="2" class="text-right">TOTAL Bs.</td>
                <td class="item-td text-right">{{ numeralFormat(factura.montoTotal) }}</td>
              </tr>
              <tr class="item-tr">
                <td :colspan="2" class="text-right">MONTO GIFT CARD Bs.</td>
                <td class="item-td text-right">{{ numeralFormat() }}</td>
              </tr>
              <tr class="item-tr">
                <td :colspan="2" class="text-right">MONTO A PAGAR Bs.</td>
                <td class="item-td text-right">{{ numeralFormat(factura.montoTotal) }}</td>
              </tr>
              <tr class="item-tr">
                <td :colspan="2" class="text-right">IMPORTE BASE CRÉDITO FISCAL Bs.</td>
                <td class="item-td text-right">{{ numeralFormat(factura.montoTotal) }}</td>
              </tr>
            </tbody>
          </table>

          <v-row no-gutters style="margin-top:2em">
            <v-col style="font-size:0.80em;text-align:center">
              <p>
                ESTA FACTURA CONTRIBUYE AL DESARROLLO DEL PAÍS, EL USO ILÍCITO SERÁ SANCIONADO PENALMENTE DE ACUERDO A
                LEY
              </p>
              <p>
                {{ factura.leyenda }}
              </p>
              <p>
                “Este documento es la Representación Gráfica de un Documento Fiscal Digital emitido en una modalidad de
                facturación en línea”
              </p>
            </v-col>
            <v-col sm="2">
              <vue-qrcode :value="factura.qr" :errorCorrectionLevel="level" :scale="size" />
            </v-col>
          </v-row>
        </div>
        <!-- ============== -->
      </v-card-text>
      <v-divider class="my-0"></v-divider>
      <v-progress-linear v-if="cargandopdf" indeterminate />

      <div v-if="factura" class="text-center my-4">
        <a :href="factura.qr" target="_blank"> Click aqui para ver en <b>SIAT</b> </a>
      </div>
      <v-card-actions v-if="factura && matriz">
        <v-btn color="primary" vv-if="factura.impreso" :disabled="cargandopdf" small rounded @click="sendcorreo(false)">
          <v-icon class="mr-1"> mdi-printer</v-icon> Descargar
        </v-btn>
        <v-btn color="primary" vv-if="factura.impreso" :disabled="cargandopdf" small rounded @click="sendcorreo(true)">
          <v-icon class="mr-1"> mdi-send</v-icon> Enviar Por Correo
        </v-btn>
        <v-btn color="red" dark v-if="puedeAnular" small rounded @click="abrirAnularFactura()">
          <v-icon class="mr-1"> mdi-file-cancel</v-icon> Anular Factura
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" outlined small rounded @click="closeDialog">
          Cancelar <v-icon> mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-skeleton-loader v-else transition="scale-transition" height="290" type="table"> </v-skeleton-loader>
    </v-card>

    <Anular ref="anularfactura" v-on:anuladofact="anuladofact" />
  </v-row>
</template>

<script>
  // https://www.learmoreseekmore.com/2020/10/vuejs-vueqrcode.html
  import { getAccessToken } from '@/accessToken';
  import VueQrcode from 'vue-qrcode';
  import Anular from '@/views/recibos/AnularFE.vue';
  import xaxios from '@/xaxios';
  import axios from 'axios';
  import gql from 'graphql-tag';
  import moment from 'moment';
  import numeral from 'numeral';
  import { mapState } from 'vuex';

  moment.locale('es');

  export default {
    components: { VueQrcode, Anular },
    props: ['programa_id'],
    data() {
      return {
        menu_name: process.env.VUE_APP_NAME_MENU,
        api_rest: process.env.VUE_APP_API_REST,
        cssText: null,
        cargandopdf: false,

        size: 1.6,
        level: 'H',
        dialog: false,
        recibo: null,
        factura: null,
        subtotal: 0.0,
        programa: {},
        today: new Date().toISOString(),
        matriz: null,
        sucursal: null,
        nit: null,
        literal: null,
        estado: true,
        apikeytoken: '',
      };
    },
    computed: {
      puedeAnular() {
        if (!this.factura) return false;
        if (this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 14) {
          let fs = this.factura.fechaEmision;
          try {
            let a = fs.substring(0, 4);
            let m = fs.substring(4, 6);
            let d = fs.substring(6, 8);
            let inicio = new Date();
            inicio.setMonth(parseInt(m) - 1);
            inicio.setDate(parseInt(d));
            inicio.setFullYear(parseInt(a));
            let fin = new Date();
            fin.setDate(-4); // en realidad resta -34 dias, no se porque
            let dx = inicio.getTime() > fin.getTime();
            //window.console.log('>>>', fechita, inicio, fin, dx);
            return dx;
          } catch (e) {
            window.console.error(e);
            return false;
          }
        }
        return false;
      },
      ...mapState({
        sede_id: (state) => state.CARGO.sede.id,
        UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
      }),
    },
    watch: {
      programa_id(id) {
        if (id)
        xaxios.get(`${this.api_rest}/esam/programa/id/${id}`).then(({ data }) => {
            this.programa = data;
          });
      },
    },
    methods: {
      async showThisView(factura_id, recibo, facturaelectro, cargautil) {
        window.console.log('facturaelectro>>>', facturaelectro);
        window.console.log('recibolectro>>>', recibo);
        window.console.log('factura_id>>>', factura_id);

        this.dialog = true;
        this.recibo = recibo;
        if (facturaelectro) {
          /*facturaelectro.map((x) => {
            x.venta.nombreRazonSocial = x.venta.nombreRazonSocial + ''.toUpperCase();
          });*/
          this.factura = facturaelectro.venta;
          this.factura.codigoPuntoVenta = cargautil.codigoPuntoVenta;

          this.completardatos();
          this.factura.detalle = recibo.detalle;
        } else {
          this.factura = this.getFacturaData(factura_id, recibo);
        }
      },
      async completardatos() {
        // window.console.log('aqui esta la factura::: ', this.factura);
        const writtenNumber = require('written-number');
        //this.factura.qr = `https://siat.impuestos.gob.bo/consulta/QR?nit=${this.factura.nit}&cuf=${this.factura.cuf}&numero=${this.factura.numeroFactura}&t=2`;
        // this.factura.qr = `${process.env.VUE_APP_FACT_QR_SIN}/QR?nit=${this.factura.nit}&cuf=${this.factura.cuf}&numero=${this.factura.numeroFactura}&t=2`;
        this.factura.qr = this.factura.factura.urlSiat;
        this.literal = writtenNumber(this.factura.montoTotal, { lang: 'es' });
        let nits = await this.getNits();
        await this.obtenerToknFactura(this.factura.idSucursal);
        this.getSucursales(this.factura.nit, nits, this.factura.idSucursal);
      },
      async obtenerToknFactura(idsuc) {
        let tok = getAccessToken();
        const apiAxios = axios.create({
          baseURL: '',
          headers: {
            'Content-Type': 'application/json',
            Authorization: tok,
          },
        });
        this.apikeytoken = await apiAxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${idsuc}`)
          .then(({ data }) => (data.apikey ? data.apikey : ''));
      },
      getSucursales(nro_nit, nits, sucursal_id) {
        const qs = gql`query{ ${''} getSucursales{ id,nit_id,direccion,telefono,ciudad,numero_sucursal } }`;
        this.$apollo.query({ query: qs }).then(({ data }) => {
          let sucursales = data.getSucursales ? data.getSucursales : [];
          //window.console.log('>>>: ', sucursales);
          if (data.getSucursales.length) {
            this.nit = nits.find((ni) => ni.nro == nro_nit);
            sucursales = sucursales.filter((s) => s.nit_id === this.nit.id);
            this.matriz = sucursales.find((s) => s.numero_sucursal === 0);
            this.sucursal = sucursales.find((s) => s.id === sucursal_id);
            let xml = this.parsexml(this.factura.factura);
            let num_suc = this.parsexmlvalue(xml, 'codigoSucursal');
            let razonSocialEmisor = this.parsexmlvalue(xml, 'razonSocialEmisor');
            let direccion = this.parsexmlvalue(xml, 'direccion');
            let codigoPuntoVenta = this.parsexmlvalue(xml, 'codigoPuntoVenta');

            if (num_suc) this.matriz.numero_sucursal = num_suc;
            if (razonSocialEmisor) this.nit.nombre = razonSocialEmisor;
            if (direccion) this.matriz.direccion = direccion;
            if (!codigoPuntoVenta) codigoPuntoVenta = '0';
            this.factura.codigoPuntoVenta = codigoPuntoVenta;
          }
        });
      },
      getNits() {
        const qs = gql`query{ ${''} getNits{ id, nombre, descripcion, nro, estado }}`;
        return this.$apollo.query({ query: qs }).then(({ data }) => (data.getNits ? data.getNits : []));
      },

      parsefechaint(fecha) {
        let fs = '' + fecha;
        let a = fs.substring(0, 4);
        let m = fs.substring(4, 6);
        let d = fs.substring(6, 8);
        let hh = fs.substring(8, 10);
        let mm = fs.substring(10, 12);

        //window.console.log('fecha::::', d, m, a, hh, mm);
        this.factura.fecha_registro = '';
        return `${d}/${m}/${a} ${hh}:${mm}`;
      },

      getFacturaData(factura_id, recibo) {
        window.console.log('rec...>>>', recibo);
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/${factura_id}`,
          headers: {
            'Content-Type': 'application/json',
            // apikey: this.$store.getters.getApiKey,
            apikey: this.apikeytoken,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('getFacturaData: ', data);
            vue.factura = data;
            vue.factura.detalle = recibo.detalle;
            vue.completardatos();
          })
          .catch(function(error) {
            let data = error.response.data;
            window.console.log(data);
          });
      },
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.slice(0, 10).split('-');
        return `${day}/${month}/${year}`;
      },
      async anularFactura() {
        //window.console.log('PUEDE>>> ', this.puedeAnular);
        if (this.puedeAnular) {
          //if (this.factura.fecha_registro.substr(0, 7) === this.today.substr(0, 7)) {
          if (
            await this.$root.$confirm.open(
              'Anular Factura',
              '<strong> Esta accion es irreversible. <br /> Estas seguro?</strong> ',
              { color: 'red' },
            )
          ) {
            xaxios.delete(`${this.api_rest}/api/pagos/factura/id/${this.factura.id}`).then((res) => {
              this.$root.$notify.show(res.status === 200 ? 'Factura Anulada' : 'No se puede anular la Factura', {
                color: 'info',
              });
              this.$emit('fanulada');
            });
            this.closeDialog();
          }
        }
      },
      numeralFormat(value) {
        return numeral(value).format('0,0.00');
      },

      sendcorreo(sendemail) {
        this.cargandopdf = true;
        if (sendemail) this.crearpdfbase64();
        else this.crearpdf();
      },

      crearpdf() {
        let vue = this;
        let elementoParaConvertir = window.$('#factura_html').html();
        window
          .html2pdf()
          .set({
            margin: 0.5,
            filename: `Factura Electronica`,
            image: {
              type: 'jpeg',
              quality: 0.9,
            },
            html2canvas: {
              dpi: 192,
              scale: 3,
              letterRendering: true,
            },
            pagebreak: { mode: 'avoid-all' } /*corrige el salto de pagina*/,
            jsPDF: {
              unit: 'in',
              format: 'letter',
              orientation: 'portrait',
            },
          })
          .from(elementoParaConvertir)
          .toPdf()
          .output('datauristring')
          .then(function() {
            vue.cargandopdf = false;
          })
          .save()
          .catch((err) => {
            window.console.log(err);
            vue.cargandopdf = false;
          });
      },

      crearpdfbase64() {
        let vue = this;
        let elementoParaConvertir = window.$('#factura_html').html();
        window
          .html2pdf()
          .set({
            margin: 0.5,
            filename: `Factura Electronica`,
            image: {
              type: 'jpeg',
              quality: 0.9,
            },
            html2canvas: {
              dpi: 192,
              scale: 3,
              letterRendering: true,
            },
            pagebreak: { mode: 'avoid-all' } /*corrige el salto de pagina*/,
            jsPDF: {
              unit: 'in',
              format: 'letter',
              orientation: 'portrait',
            },
          })
          .from(elementoParaConvertir)
          .toPdf()
          .output('datauristring')
          .then(function() {
            //window.console.log('pdfObj::::', pdfObj);
            vue.cargandopdf = false;
          })
          //.save()
          .catch((err) => {
            window.console.log(err);
            vue.cargandopdf = false;
          });
      },

      cortarCuf(cuf) {
        let tam = cuf.length / 2;
        let a = cuf.substring(0, tam);
        let b = cuf.substring(tam);
        return `${a} ${b}`;
      },

      abrirAnularFactura() {
        this.$refs.anularfactura.openmodal(this.factura);
      },
      anuladofact() {
        this.dialog = false;
        this.recibo.factura_id = null;
        this.$emit('anuladofact', this.recibo);
      },

      closeDialog() {
        this.dialog = false;
        this.recibo = null;
        this.matriz = null;
        this.sucursal = null;
        this.factura = null;
        this.nit = null;
        this.subtotal = 0.0;
        this.form = { nombre_cliente: null, nit_cliente: null, sucursal_id: null };
      },

      parsexmlvalue(xmlDoc, key) {
        try {
          return xmlDoc.getElementsByTagName(key)[0].childNodes[0].nodeValue;
        } catch (e) {
          return '';
        }
      },
      parsexml(factura) {
        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(factura, 'text/xml');
        return xmlDoc;
      },
    },
    mounted() {
      const [day, month, year] = new Date()
        .toLocaleString('es-US', {
          timeZone: 'America/La_Paz',
          year: 'numeric',
          day: '2-digit',
          month: '2-digit',
        })
        .split('/');
      this.today = `${year}-${month}-${day}`;
      // window.console.log('variable', this.today, this.today.substr(0, 7));
      this.cssText = `
      table {
    border-collapse: collapse;
    border-spacing: 0;
    font-size: x-small;
    width: 100%;
  }
  table tbody td:first-child{
    background: transparent!important;
  }
  .tablae tr,
  .tablae td {
    border: 1px solid #999;
  }
  .trclean {
    border-left: 1px solid white !important;
    border-top: 1px solid white !important;
    border-bottom: 1px solid white !important;
  }
  .table-border {
    border: 1px solid silver;
  }
  .w-35per {
    width: 35%;
  }
  .w-98per {
    width: 98%;
  }
  .w-38per {
    width: 38%;
  }
  .w-40per {
    width: 40%;
  }
  .w-20per {
    width: 20%;
  }
  .w-24per {
    width: 24%;
  }
  .w-23per {
    width: 23%;
  }
  .w-10per {
    width: 10%;
  }
  .x-small {
    font-size: x-small;
  }
  .text-center {
    text-align: center;
  }
  .align-v-center {
    vertical-align: center;
  }
  .font-weight-bold {
    font-weight: bold;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .w-100 {
    width: 100%;
  }
  .mb-5 {
    margin-bottom: 2rem;
  }
  .mb-3 {
    margin-bottom: 1rem;
  }
  .mb-2 {
    margin-bottom: 0.7rem;
  }
  .item-th {
    font-weight: bold;
    align-items: left;
  }
  hr {
    margin-bottom: 3rem;
    margin-top: 3rem;
  }
  .float-left {
    float: left !important;
  }
  .border-box {
    border: solid 1px #4d84c7c7;
    border-radius: 0.4em;
    box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.3);
  }
  .recibo-number {
    font-weight: bold;
    color: #305077;
    /* font-size: 1.2rem; */
  }
  .img-height {
    height: 60px;
  }
  .px-2 {
    padding-left: 2em;
    padding-right: 2em;
  }
  .pa-2 {
    padding: 2em;
  }
  .mitad-solid {
    position: absolute;
    top: 50%;
  }
  .font-size-1 {
    font-size: 1rem;
  }
  .pl-1 {
    padding-left: 0.5em;
  }
  .watermark1 {
      width: 40%;
      position: absolute;
      top: 10%;
      left: 30%;
  }
  .watermark3 {
      width: 40%;
      position: absolute;
      top: 35%;
      left: 30%;
  }
  .watermark2 {
      width: 30%;
      position: absolute;
      top: 0px;
      right: 2px;
      opacity: 70%;
  }
    `;
    },
  };
  // DELETE FROM detalle_factura WHERE factura_id >5;
  // UPDATE pagos_inscripcion SET factura_id = null WHERE factura_id >5;
  // DELETE FROM facturas WHERE id >5;
</script>

<style scoped>
  table {
    border-collapse: collapse;
    border-spacing: 0;
    font-size: x-small;
    width: 100%;
  }
  table tbody td:first-child {
    background: transparent !important;
  }
  table tbody td {
    color: black !important;
  }
  .text-left {
    text-align: left;
  }
  .tablae {
    color: #000;
  }
  .tablae tr,
  .tablae td {
    border: 1px solid #999;
  }
  .trclean {
    border-left: 1px solid white !important;
    border-top: 1px solid white !important;
    border-bottom: 1px solid white !important;
  }
  .table-border {
    border: 1px solid silver;
  }
  .w-35per {
    width: 35%;
  }
  .w-98per {
    width: 98%;
  }
  .w-38per {
    width: 38%;
  }
  .w-40per {
    width: 40%;
  }
  .w-20per {
    width: 20%;
  }
  .w-24per {
    width: 24%;
  }
  .w-23per {
    width: 23%;
  }
  .w-10per {
    width: 10%;
  }
  .x-small {
    font-size: x-small;
  }
  .text-center {
    text-align: center;
  }
  .align-v-center {
    vertical-align: center;
  }
  .font-weight-bold {
    font-weight: bold;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .w-100 {
    width: 100%;
  }
  .mb-5 {
    margin-bottom: 2rem;
  }
  .mb-3 {
    margin-bottom: 1rem;
  }
  .mb-2 {
    margin-bottom: 0.7rem;
  }
  .item-th {
    font-weight: bold;
    align-items: left;
  }
  hr {
    margin-bottom: 3rem;
    margin-top: 3rem;
  }
  .float-left {
    float: left !important;
  }
  .border-box {
    border: solid 1px #4d84c7c7;
    border-radius: 0.4em;
    box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.3);
  }
  .recibo-number {
    font-weight: bold;
    color: #305077;
    /* font-size: 1.2rem; */
  }
  .img-height {
    height: 60px;
  }
  .px-2 {
    padding-left: 2em;
    padding-right: 2em;
  }
  .pa-2 {
    padding: 2em;
  }
  .pl-1 {
    padding-left: 0.5em;
  }
  .mitad-solid {
    position: absolute;
    top: 50%;
  }
  .font-size-1 {
    font-size: 1rem;
  }
  .watermark1 {
    width: 50%;
    position: absolute;
    top: 30%;
    left: 25%;
  }
  .watermark2 {
    display: none;
  }
</style>
